import { createContext } from 'react';

import type {
  RectSeriesToMetadata,
  RectSeriesWithDatapoints,
  RectSeriesIdToValueScaleDomain,
} from '../types/xy-chart-internals.js';

export interface RectDataInternal {
  seriesWithDatapoints: RectSeriesWithDatapoints[];
  seriesToMetadata: RectSeriesToMetadata;
  seriesIdToValueScaleDomain?: RectSeriesIdToValueScaleDomain;
}

export const XYChartRectDataContext = createContext<
  RectDataInternal | undefined
>(undefined);

XYChartRectDataContext['displayName'] = 'XYChartRectDataContext';
